<template>
  <div
    class="active-detail-container"
    v-if="active.cover"
    :style="{
      paddingBottom:
        active.regist_status === 1 && active.booked !== 0
          ? 'calc(50px + env(safe-area-inset-bottom, 0px))'
          : '0',
    }"
  >
    <div class="active-image-container">
      <el-image :src="'https://clubs.xinmin.cn/' + active.cover">
        <template #placeholder>
          <div class="image-slot">加载中...</div>
        </template>
        <template #error>
          <div class="image-slot image-error-slot">
            <img src="@/assets/author.png" alt="" />
          </div>
        </template>
      </el-image>
    </div>
    <div class="active-top-container">
      <h1>{{ active.title }}</h1>
      <div class="detail-tag">
        <ActiveListTag :tags="active.regist_status" />
      </div>
      <ActiveUserList :activeUserList="(datas && datas.records) || {}" />
      <CountDown
        cdText="报名中"
        cdSubText="距报名结束"
        :regEndTime="active.regist_end_time"
        v-if="active.regist_status === 1 && hasChange === 1"
        v-bind="$attrs"
      />
    </div>
    <div class="active-info-container">
      <div class="active-info-box">
        <KyIcon type="dateTime" color="#ee5f5c" class="active-icon-container" />
        <el-text>
          {{ formatDate(active.active_begin_time) }}&nbsp;至&nbsp;{{
            formatDate(active.active_end_time, true)
          }}
        </el-text>
      </div>
      <div class="active-info-box">
        <KyIcon type="location" color="#ee5f5c" class="active-icon-container" />
        <el-text>
          {{ active.address }}
        </el-text>
      </div>
      <div class="active-info-box">
        <KyIcon type="jiFen" color="#ee5f5c" class="active-icon-container" />
        <el-text :style="{ color: active.jifen === 0 ? '#03a903' : '#000' }"
          >{{ setCount }}
        </el-text>
      </div>
    </div>
    <div class="active-content-container" :style="containerMargin">
      <div
        class="active-content-box markdown-body"
        v-html="active.content"
      ></div>
    </div>
    <div v-if="storage.getItem('usertoken')">
      <div
        class="acitve-form-container userinfo-bm-input"
        :style="{ display: active.booked === 0 ? 'block' : 'none' }"
        v-if="active.regist_status === 1"
      >
        <el-text size="large" v-if="active.booked === 0">填写信息</el-text>
        <el-form
          id="data-form-container"
          ref="form"
          class="data-form-container"
          label-position="left"
          label-width="80px"
          v-if="active.booked === 0"
        >
          <div class="userinfo-input">
            <el-form-item label="姓名">
              <div class="input-area">
                <el-input
                  type="text"
                  maxlength="10"
                  v-model="formData.realname"
                  placeholder="请填写姓名"
                />
              </div>
            </el-form-item>
          </div>
          <div class="userinfo-input">
            <el-form-item label="手机号">
              <div class="input-area">
                <el-input
                  type="text"
                  maxlength="11"
                  v-model="formData.phone"
                  placeholder="请填写手机号"
                />
              </div>
            </el-form-item>
          </div>
        </el-form>
      </div>
    </div>

    <div class="active-button-container" v-if="active.regist_status === 1">
      <div class="active-button-box">
        <el-button
          type="danger"
          icon="Service"
          circle
          v-if="isShowing"
          style="margin-right: 20px"
        />
        <div class="submit-container">
          <el-button
            round
            class="submit"
            size="large"
            color="#f33434"
            :disabled="isSubmiting"
            @click.prevent="handleSubmit"
            v-if="active.booked === 0"
            >{{ isSubmiting ? "提交中..." : "立即报名" }}
          </el-button>

          <div class="active-detail-button" v-else>
            <el-button
              round
              class="submit"
              size="large"
              color="#f33434"
              :disabled="true"
              >已报名，等待活动开始
            </el-button>
          </div>
        </div>
      </div>
    </div>
    <div class="active-button-container" v-if="active.regist_status === 3">
      <div class="active-button-box">
        <div class="submit-container">
          <div class="active-detail-button">
            <el-button
              round
              class="submit"
              size="large"
              color="#f33434"
              :disabled="active.booked === 2 ? true : false"
              @click.prevent="handleSignUp"
              >{{ active.booked === 2 ? "已签到" : "立即签到" }}
            </el-button>
          </div>
        </div>
      </div>
    </div>
    <div class="allDialog">
      <el-dialog
        title="现场获取签到码进行签到"
        v-model="showDialog"
        width="70%"
        top="36vh"
        :show-close="false"
        center
        destroy-on-close
      >
        <div>
          <el-input placeholder="请填写签到码" v-model="signupcode" />
        </div>
        <template #footer>
          <div class="dialog-footer">
            <el-button @click="showDialog = false">取 消</el-button>
            <el-button @click="confirmSignUp" style="color: #25ad25"
              >签到</el-button
            >
          </div>
        </template>
      </el-dialog>
    </div>
  </div>
</template>
<script>
import fetchData from "@/mixins/fetchData.js";
import { getActiveUserList } from "@/api/active.js";
import { setWxShare } from "@/api/wxShare";
import { formatDate } from "@/utils";
import KyIcon from "@/components/KyIcon";
import CountDown from "@/components/CountDown";
import ActiveUserList from "./ActiveUserList";
import ActiveListTag from "./ActiveListTag";
export default {
  components: {
    ActiveUserList,
    ActiveListTag,
    KyIcon,
    CountDown,
  },
  props: {
    active: {
      type: Object,
      required: true,
    },
    hasChange: {
      type: Number,
    },
  },
  mixins: [fetchData({ records: [] })],
  data() {
    return {
      formData: {
        realname: "",
        phone: "",
      },
      title: "",
      keyword: "",
      link: "",
      imgUrl: "",
      isSubmiting: false,
      isShowing: false,
      storage: window.localStorage,
      showDialog: false,
      signupcode: "",
      active_status: 0,
    };
  },
  watch: {
    active: {
      immediate: true,
      handler(newVal) {
        this.fetchData();
        this.title = newVal.title;
        this.keyword = newVal.keyword;
        this.link = `https://clubs.xinmin.cn/dzclub/index.html#/active/${this.$route.params.aid}`;

        setWxShare({
          title: this.title,
          desc: this.keyword,
          link: this.link,
          imgUrl: "https://clubs.xinmin.cn/dzclub/share.png",
        });
      },
    },
  },
  unmounted() {
    setWxShare();
  },
  methods: {
    formatDate,
    async fetchData() {
      const aid = this.$route.params.aid;
      const limit = this.active.regist_status === 4 ? 20 : 10;
      const res = await getActiveUserList(aid, limit);
      this.datas = res;
    },
    handleSubmit() {
      this.isSubmiting = true;
      this.$emit("submit", this.formData, (status, message) => {
        if (status) {
          this.$message.success({
            message: message,
            center: true,
            offset: 90,
            duration: 1500,
            customClass: "message-class",
            onClose: () => {
              this.isSubmiting = false;
              // eslint-disable-next-line
              this.active.booked = 1;
            },
          });
        } else {
          this.$message.warning({
            message: message,
            center: true,
            offset: 90,
            duration: 1500,
            customClass: "message-class",
            onClose: () => {
              this.isSubmiting = false;
            },
          });
        }
      });
    },
    handleCancel() {
      this.isSubmiting = true;
      this.$emit("cancel", {}, (status, message) => {
        if (status) {
          this.$message.success({
            message: message,
            center: true,
            offset: 90,
            duration: 1500,
            customClass: "message-class",
            onClose: () => {
              this.isSubmiting = false;
              // eslint-disable-next-line
              this.active.booked = 0;
            },
          });
        } else {
          this.$message.warning({
            message: message,
            center: true,
            offset: 90,
            duration: 1500,
            customClass: "message-class",
            onClose: () => {
              this.isSubmiting = false;
            },
          });
        }
      });
    },
    handleSignUp() {
      this.showDialog = true;
    },
    confirmSignUp() {
      if (!this.signupcode) {
        return this.$message.warning({
          message: "请填写签到码",
          center: true,
          offset: 90,
          duration: 1500,
          customClass: "message-class",
        });
      }
      this.$emit("signUp", this.signupcode, (status, message) => {
        if (status) {
          this.$message.success({
            message: message,
            center: true,
            offset: 90,
            duration: 1500,
            customClass: "message-class",
            onClose: () => {
              this.showDialog = false;
              // eslint-disable-next-line
              this.active.booked = 2;
            },
          });
        } else {
          this.$message.warning({
            message: message,
            center: true,
            offset: 90,
            duration: 1500,
            customClass: "message-class",
          });
        }
      });
    },
  },
  computed: {
    setCount() {
      if (this.active.jifen < 0) {
        return `本活动报名需消耗${Math.abs(this.active.jifen)}积分`;
      } else if (this.active.jifen === 0) {
        return "公益";
      } else {
        return `报名即可获得${this.active.jifen}积分`;
      }
    },
    containerMargin() {
      const safeArea = "env(safe-area-inset-bottom, 0px)";
      switch (this.active.regist_status) {
        case 3:
          return {
            margin: `10px auto calc(56px + ${safeArea})`,
          };
        case 4:
          return {
            margin: `10px auto ${safeArea}`,
          };
        default:
          return {
            margin: "10px auto",
          };
      }
    },
  },
};
</script>
<style lang="less" scoped>
@import "~@/styles/mixin.less";
@import "~@/styles/markdown.css";

@margin5auto: 5px auto;
@margin10auto: 10px auto;

.active-detail-container {
  overflow: hidden;
  overflow-y: auto;
  scroll-behavior: smooth;
  text-align: left;
  // margin: 0 auto calc(56px + env(safe-area-inset-bottom, 0px));

  .image-slot {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 100%;
    object-fit: cover;
    background: var(--el-fill-color-light);
    color: var(--el-text-color-secondary);
    font-size: 16px;
  }
  .image-error-slot {
    width: 100%;
    height: 200px;
    img {
      width: 40%;
    }
  }
  h1 {
    font-size: 16px;
    margin: @margin5auto;
    letter-spacing: 1px;
  }
  .detail-tag {
    .self-flex(space-between);
    align-items: center;
    margin: @margin10auto;
    .el-tag {
      margin-right: 5px;
    }
  }
}

.active-top-container,
.active-info-container,
.active-content-container,
.acitve-form-container {
  background-color: #fff;
  padding: 10px;
  // margin-bottom: 10px;
}

.active-detail-container .acitve-form-container {
  margin-bottom: calc(56px + env(safe-area-inset-bottom, 0px));
}

.acitve-form-container {
  .el-text {
    display: block;
    margin-bottom: 10px;
    font-size: 18px;
    font-weight: 600;
    letter-spacing: 1px;
    color: var(--000);
  }
}

.userinfo-input {
  padding-bottom: 20px;
}

.active-button-container {
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  width: 100%;
  margin: auto;
  max-width: 750px;
  background-color: var(--fff);
  border-top: 2px solid #f5f5f5;
  padding-bottom: calc(env(safe-area-inset-bottom, 0px));
  .active-button-box {
    .self-flex(space-between);
    align-items: center;
    padding: 10px;
    .submit-container {
      .self-flex();
      flex: 1 1 auto;
      .el-button {
        flex: 1 1 auto;
      }
    }
  }
}

.active-info-box {
  .self-flex(flex-start);
  align-items: center;
  margin-bottom: 20px;
  .el-text {
    color: var(--000);
  }
  &:last-child {
    margin-bottom: 0;
  }
}

.active-icon-container {
  .active-icon(15px);
  margin-right: 10px;
  flex: 0 0 auto;
}

.active-detail-button {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 10px;
  width: 100%;
  button {
    margin: auto;
  }
}
</style>